import { isStreamingDictationAvailable } from '@/utils/backendSurfaces';
import { type Editor } from '@tiptap/react';
import { defineMessages } from 'react-intl';

import { formatMessageOutsideReact } from '@heidi/runtime/i18n';

const dictationRecorderMessages = defineMessages({
  microphonePermissionDenied: {
    defaultMessage: 'Microphone permission denied. Please allow access to continue',
    id: 'Tyf82Nb52m',
    description: 'Error shown when dictation cannot access the microphone',
  },
});

export const getMicrophonePermissionDeniedMessage = () =>
  formatMessageOutsideReact(dictationRecorderMessages.microphonePermissionDenied);

export interface DictationRecorderStartArgs {
  token: string;
  editor: Editor;
  deviceId?: string;
  onError?: (errorMessage?: string) => void;
  onSuccess?: () => void;
}

export interface DictationRecorder {
  onStart(args: DictationRecorderStartArgs): Promise<void>;
  stop(): void;
  isBoundTo(editor: Editor): boolean;
}

export type DictationTransport = 'streaming' | 'chunked';

// With no streaming transcriber behind the dictation WebSocket, audio goes to
// the backend as short chunks over HTTP and no socket is opened.
export const getDictationTransport = (): DictationTransport =>
  isStreamingDictationAvailable ? 'streaming' : 'chunked';

// The chunk route is session-scoped; the WebSocket has a sessionless variant
// for template creation and onboarding.
export const isDictationAvailable = (sessionId: string | null | undefined) =>
  getDictationTransport() === 'streaming' || Boolean(sessionId);
